export default {
    general: {
      errors: {
        usernameNotFoundInDatabase: "Логін не знайдений в базі",
        usernameOrPasswordNotFound: "Логін або пароль не знайдені",
        accessDenied: "Доступ заборонено",
        invalidUsernameOrPassword: "Некоректний логін або пароль",
        accountExpired: "Термін дії облікового запису завершено",
        sessionExpired: "Час життя сесії минув",
        notModified: "Змін в базі не зроблено"
      },
      errorMessages: {
        details: 'докладніше',
        error: 'Помилка',
        login: {
          noUsername:   "Необхідно ввести ім'я користувача",
          noPassword : "Необхідно ввести пароль",
          noLanguage: "Необхідно вибрати мову",
          noConnection: "Необхідно вибрати підключення"
        }
      }
    }
  };
  